import { render, staticRenderFns } from "./PlayerMatchStats.vue?vue&type=template&id=50f9caad&"
import script from "./PlayerMatchStats.vue?vue&type=script&lang=ts&"
export * from "./PlayerMatchStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChipGroup})
